<template>
  <div id="page-applicant-mailer">
    <vx-card>
      <div slot="no-body" class="p-6">
        <h1 class="mb-8">SMS Versenden</h1>
        <form @submit.prevent>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <h4>Historie</h4>
            </div>
            <div class="vx-col w-full md:w-1/3">
              <DataInput
                v-model="createHistoryEntry"
                type="bool"
                class="w-full mt-4"
                label="In Historie abspeichern"
                name="history"
              />
            </div>
            <div class="vx-col w-full md:w-2/3">
              <DataInput
                v-model="history.typeID"
                type="model"
                class="w-full mt-4"
                label="Art"
                name="typeID"
                model-label="nameHistory"
                select-label="nameHistory"
                gql-query="actionTypes"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <h4>Wiedervorlage</h4>
            </div>
            <div class="vx-col w-full md:w-1/5">
              <DataInput
                v-model="createResubmission"
                type="bool"
                class="w-full mt-4"
                label="Aktivieren"
                name="resubmission"
              />
            </div>
            <div class="vx-col w-full md:w-1/5">
              <DataInput
                v-model="resubmission.consultantID"
                type="model"
                class="w-full mt-4"
                label="Berater"
                name="consultantID"
                model-label="
                  firstName
                  lastName"
                :select-label="el => el.firstName + ' ' + el.lastName"
                gql-query="consultantsPage"
                gql-single-query="consultant"
                gql-filter-type="objectFilter"
              />
            </div>
            <div class="vx-col w-full md:w-1/5">
              <DataInput
                v-model="resubmission.dueAt"
                type="date"
                class="w-full mt-4"
                label="am"
                name="date"
              />
            </div>
            <div class="vx-col w-full md:w-1/5">
              <DataInput
                v-model="resubmission.typeID"
                type="model"
                class="w-full mt-4"
                label="Art"
                name="typeID"
                model-label="nameResubmission"
                select-label="nameResubmission"
                gql-query="actionTypes"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <h3>SMS</h3>
            </div>
            <div class="vx-col w-full">
              <DataInput
                v-model="smsForm.title"
                class="w-full mt-4"
                label="Titelzeile"
                name="title"
              />
            </div>
            <div class="vx-col w-full plaintext-input">
              <DataInput
                v-model="smsForm.text"
                class="w-full mt-4"
                label="Text"
                name="text"
              />
            </div>
          </div>
          <vs-button @click="submit">Senden</vs-button>
        </form>
      </div>
    </vx-card>
  </div>
</template>

<script>
import DataInput from "@/components/ui/DataInput";
import gql from "graphql-tag";

export default {
  components: {
    DataInput
  },
  data: () => ({
    smsForm: {
      title: null,
      text: null
    },
    resubmission: {},
    history: {},
    createResubmission: false,
    createHistoryEntry: true
  }),
  apollo: {
    applicant: {
      query: gql`
        query Applicant($id: ID!) {
          applicant(id: $id) {
            id
            salutation
            firstName
            lastName
            createdAt
            contactData {
              telephone
              telephoneMobile
              address {
                street
                zip
                city
              }
            }
          }
        }
      `,
      variables() {
        return {
          id: this.$route.params.id
        };
      }
    },
    me: gql`
      query {
        me {
          id
          email
          consultant {
            id
            firstName
            lastName
            position
            telephone
            telephoneOffice
            fax
            zip
            city
            street
          }
        }
      }
    `
  },
  computed: {
    templateData() {
      return {
        applicant: this.applicant,
        consultant: this.me ? this.me.consultant : {},
        user: this.me ? this.me : {}
      };
    }
  },
  methods: {
    async submit() {
      let $this = this;

      await this.$apollo.mutate({
        mutation: gql`
          mutation SendSms($applicantID: ID!, $input: ApplicantSMSInput!) {
            sendApplicantSMS(applicantID: $applicantID, input: $input) {
              messageStatus
              spryngStatus
              message
            }
          }
        `,
        variables: {
          applicantID: this.$route.params.id,
          input: {
            title: this.smsForm.title,
            text: this.smsForm.text ? this.smsForm.text : "",
            sendFrom: this.me.telephoneMobile
          }
        },
        update(_, { data: { sendApplicantSMS } }) {
          if (
            sendApplicantSMS.messageStatus != "SUCCESFULL" ||
            sendApplicantSMS.spryngStatus != "OK"
          ) {
            $this.$vs.notify({
              title: "SMS Fehler",
              text:
                "SMS Status: " +
                sendApplicantSMS.messageStatus +
                "\nSpryngStatus: " +
                sendApplicantSMS.spryngStatus +
                "\nNachricht: " +
                sendApplicantSMS.message,
              color: "danger",
              icon: "query_builder",
              position: "bottom-center",
              fixed: "true"
            });
            $this.successfull = false;
          } else {
            $this.successfull = true;
          }
        }
      });

      if (!this.successfull) {
        return;
      }

      if (this.createResubmission) {
        this.$apollo
          .mutate({
            mutation: gql`
              mutation($input: NewAction!) {
                createAction(input: $input) {
                  id
                }
              }
            `,
            variables: {
              input: {
                ...this.resubmission,
                description: this.smsForm.text,
                done: false,
                refID: this.$route.params.id,
                refType: "APPLICANT"
              }
            }
          })
          .catch(error => {
            this.loginErrors = error.graphQLErrors.map(m => m.message);
          });
      }

      if (this.createHistoryEntry) {
        this.$apollo
          .mutate({
            mutation: gql`
              mutation($input: NewAction!) {
                createAction(input: $input) {
                  id
                }
              }
            `,
            variables: {
              input: {
                ...this.history,
                description: this.smsForm.text,
                done: true,
                refID: this.$route.params.id,
                refType: "APPLICANT",
                consultantID: this.me.consultant.id,
                dueAt: new Date(),
                title: this.smsForm.title
              }
            }
          })
          .catch(error => {
            this.loginErrors = error.graphQLErrors.map(m => m.message);
          });
      }

      this.$vs.notify({
        title: "Abgeschickt",
        text: "Alles wurde erfolgreich abgeschickt!",
        color: "success",
        icon: "query_builder",
        position: "bottom-center"
      });

      this.$router.push({
        name: "applicant.edit",
        params: { id: this.$route.params.id }
      });
    }
  }
};
</script>
